import { Component, AfterViewInit, EventEmitter, Output, OnInit } from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UsuarioService } from 'src/app/services/usuarios.service';
import { environment } from 'src/environments/environment';
import { setConfigTable, validarCodigoExistentesComercial, basicAlert, obtenerFechaSeleccionada, obtenerFechaActual, timerOut, filtrarCoincidenciaArrayTransportista, validarInputVacio, alertaConfirmacion, openDescripcion, openObservacion, alertaConfirmacionHTML , openInsertarNumint, openReutilizar } from 'src/app/shared/utils';
import { documentoService } from 'src/app/services/documento.service';
import { MdDocSerienumeroComponent } from '../modals/md-doc-serienumero/md-doc-serienumero.component';
import { MdDocumentoComponent } from 'src/app/shared/modals/md-documento/md-documento.component';
import { MdClienteNuevoComponent } from '../modals/md-cliente-nuevo/md-cliente-nuevo.component';
import { MdProveedorNuevoComponent } from '../modals/md-proveedor-nuevo/md-proveedor-nuevo.component';
import { MdArticuloNuevoComponent } from '../modals/md-articulo-nuevo/md-articulo-nuevo.component';
import { MdPanelControlUsuarioComponent } from '../modals/md-panel-control-usuario/md-panel-control-usuario.component';
import { MdAvisoEstadoCuentaClienteComponent } from '../modals/md-aviso-estado-cuenta-cliente/md-aviso-estado-cuenta-cliente.component';
import { VersionService } from 'src/app/services/version.service';


declare var $: any;

@Component({
  selector: 'app-vertical-navigation',
  templateUrl: './vertical-navigation.component.html'
})
export class VerticalNavigationComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  public sessionInfo: any = null;

  public config: PerfectScrollbarConfigInterface = {};

  public showSearch = false;

  public production : boolean;

  // This is for Notifications
  notifications: Object[] = [
    {
      btn: 'btn-danger',
      icon: 'ti-link',
      title: 'Luanch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM'
    },
    {
      btn: 'btn-success',
      icon: 'ti-calendar',
      title: 'Event today',
      subject: 'Just a reminder that you have event',
      time: '9:10 AM'
    },
    {
      btn: 'btn-info',
      icon: 'ti-settings',
      title: 'Settings',
      subject: 'You can customize this template as you want',
      time: '9:08 AM'
    },
    {
      btn: 'btn-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/user1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: 'assets/images/users/user2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: 'assets/images/users/user2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM'
    },
    {
      useravatar: 'assets/images/users/user4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'us'
  }

  public languages: any[] = [{
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'us'
  },
  {
    language: 'Español',
    code: 'es',
    icon: 'es'
  },
  {
    language: 'Français',
    code: 'fr',
    icon: 'fr'
  },
  {
    language: 'German',
    code: 'de',
    icon: 'de'
  }]



  constructor(private modalService: NgbModal, private translate: TranslateService,
              private spinnerService: SpinnerService,
              private router: Router,
              private storageService: StorageService,              
               private versionService: VersionService,
              private usuarioActivo: UsuarioService,
              private documentoService: documentoService,
              )
  {
    translate.setDefaultLang('en');
    this.production = environment.production
  }

  changeLanguage(lang: any) {
    this.translate.use(lang.code)
    this.selectedLanguage = lang;
  }

  logout(){
    this.sessionInfo = JSON.parse(StorageService.getSession());
    if (this.sessionInfo != null) {
      /* this.spinnerService.activarLoading(true);
      this.usuarioActivo.logout(this.sessionInfo.coduser).subscribe((res: any) => {
        this.spinnerService.activarLoading(false);
        console.log(res);
        StorageService.clearStorage();
        this.router.navigateByUrl('/login');
      }, err => {
        this.spinnerService.activarLoading(false);
        console.log(err);
        // basicAlert(err.error, 'warning', 'Aceptar');
      }) */

      StorageService.clearStorage();
      this.router.navigateByUrl('/login');
    }

  }

  ngOnInit() {
    this.sessionInfo = JSON.parse(StorageService.getSession());
   }


   RouteDocumentoXNumint() {
    openInsertarNumint('Documento').then(valor => {
      let verificarValor = valor[0].trim(); 
      if(verificarValor) {
        this.openModalDocumentoxNumint(verificarValor)
      }else{
        basicAlert('No hay resultados con los filtros seleccionados', 'warning', 'Aceptar', null, null);
      }
    });
  }
  
  RouteDocumentoXSerieNumero() {
    openReutilizar('Documento').then(valor => {
      if (valor) {
        if (Array.isArray(valor)) {
          valor[0] = valor[0].replace(/\s+/g, '').toUpperCase(); 
          valor[1] = valor[1].trim(); 
  
          this.documentoService.obtenerDetalleDocumentov2(valor[0], +valor[1]).subscribe((response: any) => {
            console.log(response);
  
            if (response.body.length > 0) {
              if (response.body.length > 1) {
                this.openModalResultSerieNumero(response.body);
              } else {
                this.openModalDocumentoxNumint(response.body[0].numint);
              }
            } else {
              this.spinnerService.activarLoading(false);
              basicAlert('No hay resultados con los filtros seleccionados', 'warning', 'Aceptar', null, null);
            }
          }, error => {
            this.spinnerService.activarLoading(false);
            basicAlert('No hay resultados con los filtros seleccionados', 'warning', 'Aceptar', null, null);
            console.log(error);
          });
  
        }
      }
    });
  }

  detalledocumento: any;
  openModalDocumentoxNumint(data: any) {
    this.spinnerService.activarLoading(true);
    this.documentoService.obtenerDetalleDocumento(data, true).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      this.detalledocumento = response.body;
      this.mostrarModalDocumento();
    }, err => {
      console.log(err);
      if (err.status == 404) {
        basicAlert('No hay resultados', 'warning', 'Aceptar', null, null);
      }
      this.spinnerService.activarLoading(false);
    });
  } 

  mostrarModalDocumento() {
    const referenciaModal = this.modalService.open(MdDocumentoComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    referenciaModal.componentInstance.documento = this.detalledocumento;
    referenciaModal.componentInstance.encontrado = false;
    referenciaModal.componentInstance.enDoc = true;
    referenciaModal.componentInstance.traz = true;

  }


  openModalResultSerieNumero(data: any) {
    const referenciaModal = this.modalService.open(MdDocSerienumeroComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    referenciaModal.componentInstance.listadata = data;
    referenciaModal.result.then((data) => {
      this.spinnerService.activarLoading(false);
      console.log(data)
        this.openModalDocumentoxNumint(data.numint)
    }, (reason) => {
      console.log(reason);
    });
  } 

  RouteClienteNuevo() {
    //this.router.navigateByUrl('/modulo/archivos/proveedor/lista')
    const referenciaModal = this.modalService.open(MdClienteNuevoComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    referenciaModal.result.then((data) => {
      console.log(" data devuelta");
      console.log(data);
    }, (reason) => {
      console.log(reason);
    });
  }
  RouteProveedorNuevo() {

    //this.router.navigateByUrl('/modulo/archivos/proveedor/lista')
    const referenciaModal = this.modalService.open(MdProveedorNuevoComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    referenciaModal.result.then((data) => {
      console.log(" data devuelta");
      console.log(data);
    }, (reason) => {
      console.log(reason);
    });
  }
  RouteArticuloNuevo() {
    //this.router.navigateByUrl('/modulo/archivos/articulos/articulo/lista')
    const referenciaModal = this.modalService.open(MdArticuloNuevoComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
    referenciaModal.result.then((data) => {
      console.log(" data devuelta");
      console.log(data);
    }, (reason) => {
      console.log(reason);
    });
  }
  abrirModalEstadoCuentaCliente(){
    this.spinnerService.activarLoading(true);
    this.versionService.obtenerEstadoCuentaClientes(this.sessionInfo.ruc,true,true,'1').subscribe((response:any)=>{
     this.spinnerService.activarLoading(false);
       this.mostrarModalEECC(response.body.lista);
           
    },err=>{
       this.spinnerService.activarLoading(false);
       basicAlert('No tiene deuda pendiente.','success','Aceptar');
    })
 }
 mostrarModalEECC(listaFacturas:any){
   const referenciaModal = this.modalService.open(MdAvisoEstadoCuentaClienteComponent, { backdrop: 'static', size: 'xl' });
   referenciaModal.componentInstance.facturas=listaFacturas;
   referenciaModal.result.then((data) => {
     console.log("Cerrando modal", data);
   }, (reason) => {
     console.log(reason);
   });
 }
 openModalPanelControlUsuario() {
  const referenciaModal = this.modalService.open(MdPanelControlUsuarioComponent, { scrollable: true, backdrop: 'static', windowClass: 'md-panel-control'});
  referenciaModal.result.then((data) => {
    console.log(" data devuelta");
    console.log(data);
  }, (reason) => {
    console.log(reason);
  });
}
}
